// Het eerste meetmoment van een onderzoek: laagste `Position` (ontbreekt die of
// is hij leeg, dan telt hij als 0), bij gelijkspel het laagste `ID`. Het ID
// breekt het gelijkspel zodat de uitkomst niet per Firestore-snapshot wisselt.
// AI-CONTEXT: See docs/pitfalls.md#database-coarse-sort-key-ties-break-arbitrarily
//
// Dit is de platformregel, niet een eigen variant: de server gebruikt hem om te
// bepalen of een invulling een voormeting is (`kindOfMoment` in
// functions/addressMatching/matchQuestionnaireAddress.js, `eersteMoment` in
// functions/households/ensureParticipationCore.js) en de briefpagina om de
// voormeting-brief te kiezen (`momentKindOf`). De kwalificeringsvragen moeten op
// precies dát meetmoment staan. Tot de /complete-ronde van 2026-10-28 stond hier
// een eigen regel (datum als tweede sleutel, ontbrekende Position achteraan);
// die week af bij gelijke Positions. Bewaakt door
// functions/addressMatching/firstMeasureMoment.parity.test.js — wijzig de regel
// nooit hier alleen.

import notDeleted from '../notDeleted'

/**
 * @typedef {object} MeasureMomentDoc
 * @property {string} ID
 * @property {string} [docid] - Firestore-documentnaam
 * @property {number|string} [Position]
 * @property {*} [Moment] - Date, Firestore Timestamp of datumtekst (telt niet mee in de volgorde)
 * @property {Array<string>} [ExcludedFieldIDs]
 * @property {boolean|string} [Deleted]
 */

/**
 * @param {MeasureMomentDoc} a
 * @param {MeasureMomentDoc} b
 * @returns {number}
 */
export const compareMeasureMoments = (a, b) => (
    (Number(a.Position) || 0) - (Number(b.Position) || 0)
    || String(a.ID ?? '').localeCompare(String(b.ID ?? ''))
)

/**
 * @param {Array<MeasureMomentDoc> | null | undefined} moments - De meetmomenten van één onderzoek
 * @returns {MeasureMomentDoc | null} null als er geen levend meetmoment is.
 */
const firstMeasureMoment = (moments) => {
    const alive = (Array.isArray(moments) ? moments : []).filter(notDeleted)
    if (alive.length === 0) return null
    return [...alive].sort(compareMeasureMoments)[0]
}

export default firstMeasureMoment
